import { FETCH_LOV_ZIPCODE } from "../constants/actions.type";
import {
  SET_LOV_ZIPCODE,
  SET_LOV_LOADING,
  SET_LOV_ERROR
} from "../constants/mutations.type";
import ZipCodeService from "@/services/resources/zip-code.service";

const initialState = () => ({
  lovZipCode: [],
  error: true,
  loading: false
});

const states = initialState();

const getters = {
  lovZipCode(state) {
    return state.lovZipCode;
  },
  lovLoading(state) {
    return state.loading;
  },
  lovError(state) {
    return state.error;
  }
};

const actions = {
  [FETCH_LOV_ZIPCODE](context) {
    return new Promise(resolve => {
      context.commit(SET_LOV_LOADING, true);
      ZipCodeService.getLov({
        // searchBy: search,
        typeData: context.getters.isAdmin ? "all" : "byBranch"
      })
        .then(({ data }) => {
          const { message, result } = data;
          if (message == "OK") {
            let lovZipCode = result;
            lovZipCode.sort((a, b) => parseInt(a.code) - parseInt(b.code));
            context.commit(SET_LOV_ZIPCODE, lovZipCode);
            resolve(data);
          }
        })
        .catch(({ response }) => {
          const { data } = response;
          if (response) {
            context.commit(SET_LOV_ERROR, data.message);
          }
        })
        .finally(() => context.commit(SET_LOV_LOADING, false));
    });
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [SET_LOV_ERROR](state, error) {
    state.errors = error;
  },
  [SET_LOV_LOADING](state, data) {
    state.loading = data;
  },
  [SET_LOV_ZIPCODE](state, data) {
    state.lovZipCode = data;
  }
};

export default {
  // namespaced: true,
  state: states,
  getters,
  actions,
  mutations
};
